import envConfig from '@app/enviroment/enviroment';
import { UserManager, UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
// Log.setLogger(console);
// Log.setLevel(Log.DEBUG);
const KEYCLOAK_CLIENT_ID = envConfig.getEnvKey('KEYCLOAK_CLIENT_ID');
const KEYCLOAK_URL = envConfig.getEnvKey('KEYCLOAK_URL');
const KEYCLOAK_REALM = envConfig.getEnvKey('KEYCLOAK_REALM');

const oidcConfig: UserManagerSettings = {
  authority: `${KEYCLOAK_URL}/realms/${KEYCLOAK_REALM}`,
  client_id: KEYCLOAK_CLIENT_ID as string,
  redirect_uri: window.location.origin + '/auth/callback',
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid profile email',

  /**
   * Silent renewal configuration
   * Use token refresh instead of iframe session monitoring
   */
  automaticSilentRenew: true,
  silent_redirect_uri: window.location.origin + '/auth/silent-renew.html',
  accessTokenExpiringNotificationTimeInSeconds: 60, // Start renewal 60 seconds before expiry

  /**
   *  Session monitoring
   *  DISABLED: Keycloak session iframe check causes 'login_required' errors
   *  and triggers unwanted logout events. Use token refresh instead.
   */
  monitorSession: false,
  // checkSessionIntervalInSeconds: 10,

  // Additional settings for reliability
  filterProtocolClaims: true, // Filter out protocol claims from the user object

  // sessionStorage: tokens die with the tab. A new tab signs in again through Keycloak's
  // own SSO cookie, without the login form. (A tab opened with window.open, or duplicated
  // by the user, starts with a copy.)
  userStore: new WebStorageStateStore({
    store: window.sessionStorage,
  }),
};

// The one UserManager: OidcProvider runs on it and the API clients read tokens from it.
export const userManager = new UserManager(oidcConfig);

const LEGACY_USER_PREFIX = 'oidc.user:';

// Older builds kept the tokens, including an offline refresh token that outlives logout,
// in localStorage. Revoke each stored refresh token (best effort) and delete the keys.
export const purgeLegacyTokens = () => {
  for (const key of Object.keys(window.localStorage)) {
    if (key.startsWith(LEGACY_USER_PREFIX)) {
      // The key is oidc.user:<authority>:<client_id>, and the authority itself holds colons.
      const rest = key.slice(LEGACY_USER_PREFIX.length);
      const authority = rest.slice(0, rest.lastIndexOf(':'));
      const clientId = rest.slice(rest.lastIndexOf(':') + 1);
      let refreshToken: string | undefined;
      try {
        refreshToken = JSON.parse(window.localStorage.getItem(key) ?? '{}').refresh_token;
      } catch {
        refreshToken = undefined;
      }
      if (refreshToken && authority.startsWith('https://')) {
        void fetch(`${authority}/protocol/openid-connect/revoke`, {
          method: 'POST',
          keepalive: true,
          body: new URLSearchParams({ token: refreshToken, token_type_hint: 'refresh_token', client_id: clientId }),
        }).catch(() => undefined);
      }
      window.localStorage.removeItem(key);
    } else if (key === 'oidc_access_token' || key === 'jwt_token') {
      window.localStorage.removeItem(key);
    }
  }
};

export default oidcConfig;
